import React from "react";

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";

interface SelectableMenuCardProps {
  title: string;
  text: string;
  onClick: () => void;
  selected: boolean;
  icon?: React.ReactNode;
  disabled?: boolean;
  width?: string;
  height?: string;
  logo?: React.ReactNode;
  flag?: string;
  flagDesc?: string;
}

export const SelectableMenuCard: React.FC<SelectableMenuCardProps> = ({
  title,
  text,
  onClick,
  selected,
  icon,
  disabled = false,
  width,
  height,
  logo,
  flag,
  flagDesc,
}) => {
  const theme = useTheme();

  return (
    <Box position="relative">
      <Card
        sx={{
          width: width ?? "236px",
          height: height ?? "100%",
          border: selected ? 1 : 0,
          borderColor: theme.palette.secondary.main,
          // height: height ?? '344px'
        }}
      >
        <CardActionArea onClick={onClick} disabled={disabled}>
          <CardHeader
            disableTypography
            avatar={icon ? icon : null}
            title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              >
              <Typography variant="body1">{title}</Typography>
              {flag &&
                <HelpBox title={flagDesc}>
                  <Chip
                    label={flag}
                    size="small"
                    color="primary"
                  />
                </HelpBox>
              }
            </Box>
            }
            sx={{ pb: 0 }}
          />
          <CardContent
            sx={{ height: `calc(${height} - 40px)` ?? "calc(100% - 40px)" }}
          >
            <Stack height="100%" justifyContent="space-between">
              <Typography variant="body2">{text}</Typography>
              {logo && (
                <Box display="flex" justifyContent="flex-end">
                  {logo}
                </Box>
              )}
            </Stack>
          </CardContent>
        </CardActionArea>
      </Card>
      {disabled && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          zIndex={2}
          sx={{
            backgroundColor: alpha(theme.palette.background.default, 0.5),
          }}
        />
      )}
    </Box>
  );
};

export default SelectableMenuCard;
